import Footer from '../components/Footer';
import AINotetakerHero from '../components/sections/AINotetakerHero';
import AINotetakerSignup from '../components/sections/AINotetakerSignup';

function AINotetakerPage() {
  return (
    <>
      <AINotetakerHero />
      <AINotetakerSignup />
      <Footer isGray={true} />
    </>
  );
}

export default AINotetakerPage;
